import { render } from "./kinside-partner-badge.vue?vue&type=template&id=cda01eaa"
import script from "./kinside-partner-badge.vue?vue&type=script&lang=js"
export * from "./kinside-partner-badge.vue?vue&type=script&lang=js"

import "./kinside-partner-badge.vue?vue&type=style&index=0&id=cda01eaa&lang=scss"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__